var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import axios from 'axios';
import isEqual from 'lodash/isEqual';
import { AutoComplete } from '../AutoComplete';
import ZoneFilter from '../Zones/zoneFilter';
import Pill from '../Nursery/NurseryPill';
import { cleanSearch, resetParam, getQuery } from '../../utils/helpers';
import { AUTO_SEARCH } from '../../actions/constats';
import { IcnSearch, IcnSearchClear } from '../../themes/icons/attributes';
import { withNurseryContext } from '../../contexts/NurseryContext';
import { withSearchContext } from '../../contexts/SearchContext';
var abortController = null;
var computeDerivedInputValue = function (props) {
    var searchTerm = props.searchTerm, nurseryName = props.nurseryName, nurserySlug = props.nurserySlug;
    var nextSearchTerm = typeof searchTerm === 'string' ? searchTerm : '';
    var matchesSlug = (nurserySlug !== null
        && nurserySlug !== undefined
        && searchTerm !== null
        && searchTerm !== undefined
        && (isEqual(nurserySlug, searchTerm)
            || (typeof nurserySlug === 'string'
                && typeof searchTerm === 'string'
                && nurserySlug.toLowerCase() === searchTerm.toLowerCase())));
    var matchesNurseryName = (nurseryName !== null
        && nurseryName !== undefined
        && searchTerm !== null
        && searchTerm !== undefined
        && (isEqual(nurseryName, searchTerm)
            || (typeof nurseryName === 'string'
                && typeof searchTerm === 'string'
                && nurseryName.toLowerCase() === searchTerm.toLowerCase())));
    if (matchesSlug || matchesNurseryName) {
        return '';
    }
    return nextSearchTerm;
};
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar(props) {
        var _this = _super.call(this, props) || this;
        _this.textInput = React.createRef();
        _this.submitButton = React.createRef();
        _this.collapse = function () {
            _this.setState({ acActive: false });
        };
        _this.handleInputChange = function (e) {
            var acActive = _this.state.acActive;
            var newValue = e.target.value;
            _this.setState({ inputValue: newValue }, function () {
                if (newValue.length >= 3) {
                    clearTimeout(_this.delay);
                    _this.delay = setTimeout(function () {
                        _this.triggerAutocomplete(newValue);
                    }, 50);
                }
                else if (acActive) {
                    if (abortController) {
                        abortController.abort();
                    }
                    _this.setState({
                        acActive: false,
                        selectedIndex: -1,
                    });
                }
            });
        };
        _this.triggerAutocomplete = function (key) {
            // Cancel any existing request
            if (abortController) {
                abortController.abort();
            }
            // Create new AbortController for this request
            abortController = new AbortController();
            var cache = new Date().getTime();
            axios
                .get("".concat(AUTO_SEARCH + key, "&").concat(cache), {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                signal: abortController.signal,
            })
                .then(function (res) {
                _this.setState({
                    acData: res.data,
                    acActive: res.data.suggestions.length > 0,
                    selectedIndex: -1,
                });
            })
                .catch(function () {
            });
        };
        _this.clearSearch = function (e) {
            var _a;
            e.preventDefault();
            _this.setState({
                inputValue: '',
                acActive: false,
                selectedIndex: -1,
            });
            var _b = _this.props, setQueries = _b.setQueries, setOrigSearchTerm = _b.setOrigSearchTerm, isNursery = _b.isNursery, nurserySlug = _b.nurserySlug;
            setOrigSearchTerm('');
            if (setQueries) {
                var currentQuery = cleanSearch(window.location.search);
                var searchWithoutRaw = resetParam(currentQuery, 'raw', false);
                var slugForReset_1 = isNursery ? nurserySlug : '';
                var nextQuery_1 = searchWithoutRaw;
                setTimeout(function () {
                    setQueries(nextQuery_1, '', 'raw', slugForReset_1 || '', '');
                }, 0);
            }
            if (typeof window !== 'undefined')
                (_a = document === null || document === void 0 ? void 0 : document.getElementById('search_input')) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
        };
        _this.handleSubmit = function (e, query, queryType) {
            var _a = _this.state, acData = _a.acData, selectedIndex = _a.selectedIndex;
            var _b = _this.props, setQueries = _b.setQueries, setOrigSearchTerm = _b.setOrigSearchTerm, activeZone = _b.activeZone;
            var passQuery = query;
            var passQueryType = queryType;
            var url;
            e.preventDefault();
            if (abortController) {
                abortController.abort();
            }
            var searchString = '';
            if (selectedIndex !== -1) {
                passQuery = acData.suggestions[selectedIndex];
                passQueryType = acData.data[selectedIndex].type;
            }
            setOrigSearchTerm(passQuery);
            searchString = 'all_plants=True';
            if (passQuery)
                searchString = getQuery(passQuery, passQueryType);
            if (activeZone !== '0') {
                searchString += "&zone=".concat(activeZone);
            }
            var slug = '';
            if (passQueryType === 'Nursery') {
                slug = acData.data[selectedIndex].slug;
            }
            var selectedData = acData.data[selectedIndex];
            if (selectedData) {
                if (selectedData.url) {
                    url = selectedData.url;
                }
                else if (selectedData.url === '') {
                    searchString = "raw=".concat(acData.suggestions[selectedIndex]);
                }
            }
            _this.setState({
                acActive: false,
                inputValue: passQuery,
                selectedIndex: -1,
            });
            setQueries(searchString, passQuery, passQueryType, slug, url);
        };
        _this.clearNurserySearch = function () {
            var _a = _this.props, setQueries = _a.setQueries, showNurseryHeader = _a.showNurseryHeader, history = _a.history, setNurseryName = _a.setNurseryName, setNurserySlug = _a.setNurserySlug;
            setNurseryName('');
            setNurserySlug('');
            if (window.location.pathname.indexOf('/plants/') === -1) {
                var rawSearchParams = new URLSearchParams(window.location.search);
                var rawQuery_1 = (window.location.search && window.location.search.split('?')[1]) || '';
                var rawValue_1 = rawSearchParams.get('raw') || '';
                var performSearchReset = function () {
                    if (setQueries && rawQuery_1) {
                        setQueries(rawQuery_1, rawValue_1, 'raw');
                    }
                    else {
                        history === null || history === void 0 ? void 0 : history.push('/search/', { getAPIData: true });
                    }
                };
                // Ensure nursery context updates propagate before triggering a new search route
                setTimeout(performSearchReset, 0);
            }
            else {
                var path = window.location.href.split('?')[0].split('/plants/')[1];
                history === null || history === void 0 ? void 0 : history.push("/plants/".concat(path));
            }
            showNurseryHeader(false);
        };
        _this.handleAutocompleteDismiss = function (e) {
            if (e.target !== _this.textInput.current && e.target !== _this.submitButton.current) {
                _this.setState({
                    acActive: false,
                    selectedIndex: -1,
                }, function () { return _this.handleInputKeyDown(e); });
            }
        };
        _this.handleInputKeyDown = function (e) {
            var _a = _this.state, acActive = _a.acActive, acData = _a.acData, selectedIndex = _a.selectedIndex;
            if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && acActive) {
                e.preventDefault();
                var newState = {};
                if (e.key === 'ArrowDown') {
                    newState.selectedIndex = selectedIndex + 1;
                    if (newState.selectedIndex >= acData.suggestions.length) {
                        newState.selectedIndex = 0;
                    }
                }
                else if (e.key === 'ArrowUp') {
                    newState.selectedIndex = selectedIndex - 1;
                    if (newState.selectedIndex < 0) {
                        newState.selectedIndex = acData.suggestions.length - 1;
                    }
                }
                _this.setState(newState);
            }
        };
        _this.handleAutocompleteItemSelect = function (selectedIndex) {
            _this.setState({
                selectedIndex: selectedIndex,
            });
        };
        _this.passWidth = function (width) {
            _this.setState({
                pillWidth: "".concat(width, "px"),
            });
        };
        _this.state = {
            inputValue: '',
            acActive: false,
            acData: {
                data: [
                    {
                        first: false,
                        id: 0,
                        type: '',
                        raw: '',
                        slug: '',
                        url: '',
                    },
                ],
                query: '',
                suggestions: [],
            },
            selectedIndex: -1,
            pillWidth: '0',
            lastSyncedSearchTerm: null,
            lastSyncedNurseryName: null,
            lastSyncedNurserySlug: null,
        };
        if (typeof window !== 'undefined')
            document.addEventListener('click', _this.handleAutocompleteDismiss, false);
        return _this;
    }
    SearchBar.getDerivedStateFromProps = function (nextProps, prevState) {
        var nextSearchTerm = typeof nextProps.searchTerm === 'string' ? nextProps.searchTerm : '';
        var nextNurseryName = typeof nextProps.nurseryName === 'string' ? nextProps.nurseryName : '';
        var nextNurserySlug = typeof nextProps.nurserySlug === 'string' ? nextProps.nurserySlug : '';
        var propsChanged = nextSearchTerm !== prevState.lastSyncedSearchTerm
            || nextNurseryName !== prevState.lastSyncedNurseryName
            || nextNurserySlug !== prevState.lastSyncedNurserySlug;
        if (!propsChanged) {
            return null;
        }
        var derivedInputValue = computeDerivedInputValue(nextProps);
        var stateUpdate = {
            lastSyncedSearchTerm: nextSearchTerm,
            lastSyncedNurseryName: nextNurseryName,
            lastSyncedNurserySlug: nextNurserySlug,
        };
        if (derivedInputValue !== prevState.inputValue) {
            stateUpdate.inputValue = derivedInputValue;
        }
        return stateUpdate;
    };
    SearchBar.prototype.componentDidMount = function () {
        var _a = this.props, searchTerm = _a.searchTerm, setOrigSearchTerm = _a.setOrigSearchTerm;
        var derivedInputValue = computeDerivedInputValue(this.props);
        if (derivedInputValue === searchTerm && searchTerm !== '') {
            setOrigSearchTerm(searchTerm);
        }
    };
    SearchBar.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, setOrigSearchTerm = _a.setOrigSearchTerm, searchTerm = _a.searchTerm;
        if (searchTerm !== prevProps.searchTerm) {
            var derivedInputValue = computeDerivedInputValue(this.props);
            if (derivedInputValue === searchTerm) {
                setOrigSearchTerm(searchTerm);
            }
        }
    };
    SearchBar.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleAutocompleteDismiss, false);
    };
    SearchBar.prototype.render = function () {
        var _this = this;
        var _a = this.state, acActive = _a.acActive, acData = _a.acData, selectedIndex = _a.selectedIndex, pillWidth = _a.pillWidth, inputValue = _a.inputValue;
        var _b = this.props, zoneSetHandler = _b.zoneSetHandler, zones = _b.zones, activeZone = _b.activeZone, nursery = _b.nursery;
        var autoCompleteEl;
        var inputClass = 'search__input';
        var wrapperClass = 'search__input-wrap';
        var pill;
        var indent;
        if (acActive) {
            autoCompleteEl = (React.createElement(AutoComplete, { acData: acData, selectedIndex: selectedIndex, handleSubmit: this.handleSubmit, handleAutocompleteItemSelect: this.handleAutocompleteItemSelect }));
            wrapperClass += ' ac__active';
        }
        if (nursery) {
            pill = (React.createElement(Pill, { clearNurserySearch: this.clearNurserySearch, nursery: nursery, passWidth: this.passWidth }));
            inputClass += ' pill_active';
            indent = {
                marginLeft: pillWidth,
            };
        }
        return (React.createElement("div", { className: "search__container" },
            React.createElement("form", { onSubmit: function (e) {
                    _this.handleSubmit(e, inputValue, 'raw');
                }, className: "search__form" },
                React.createElement("div", { className: "search__count" },
                    React.createElement("a", { href: "/", className: "home_link" },
                        React.createElement("img", { className: "logo", src: "https://d17vsf20mehj1i.cloudfront.net/static/img/pl_logo_dark.svg", alt: "" }))),
                React.createElement("div", { className: "search__center" },
                    React.createElement("div", { className: wrapperClass },
                        React.createElement("input", { autoComplete: "off", spellCheck: "false", autoCapitalize: "none", autoCorrect: "off", style: indent, id: "search_input", tabIndex: 0, onBlur: this.collapse, className: inputClass, type: "text", placeholder: "Search for Plants...", value: inputValue, onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown, ref: this.textInput }),
                        React.createElement("span", { className: "search__clear", onClick: this.clearSearch, role: "button", tabIndex: -1, onKeyDown: this.clearSearch },
                            React.createElement(IcnSearchClear, { className: "icn" })),
                        React.createElement("button", { className: "search__submit", type: "submit", value: "Submit", ref: this.submitButton },
                            React.createElement(IcnSearch, { className: "icn" })),
                        pill),
                    autoCompleteEl),
                React.createElement(ZoneFilter, { activeZone: activeZone, zones: zones, zoneSetHandler: zoneSetHandler }))));
    };
    return SearchBar;
}(React.Component));
export default withNurseryContext(withSearchContext(SearchBar));
